import {createAction} from "redux-act";

export const openContextualPrompt = createAction();
export const closeContextualPrompt = createAction();
